import React from "react";
import { IonIcon, IonInput, IonRadio, IonRadioGroup } from "@ionic/react";
import { arrowBack, close } from "ionicons/icons";
import firebaseEventConfig from "../../../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../../../utils/firebaseAnalytics/firebaseUtils";
import expandIcon from "../../../theme/custom-icons/expand_more.svg";
import searchIcon from "../../../theme/custom-icons/search.svg";

interface PositionsFiltersBarProps {
  level: number;
  setLevel: (level: number) => void;
  isVisibilityDropDownOpen: boolean;
  setIsVisibilityDropDownOpen: (open: boolean) => void;
  searchVal: string;
  setSearchVal: (val: string) => void;
  isSearchBarOpen: boolean;
  setIsSearchBarOpen: (open: boolean) => void;
  searchRef: React.RefObject<HTMLIonInputElement>;
  visibilityPickerRef: React.RefObject<HTMLDivElement>;
  closeDropdowns: () => void;
}

const PositionsFiltersBar: React.FC<PositionsFiltersBarProps> = ({
  level,
  setLevel,
  isVisibilityDropDownOpen,
  setIsVisibilityDropDownOpen,
  searchVal,
  setSearchVal,
  isSearchBarOpen,
  setIsSearchBarOpen,
  searchRef,
  visibilityPickerRef,
  closeDropdowns,
}) => {
  return (
    <div
      className={`ob__filters_wrapper positions__filters_wrapper ${
        isSearchBarOpen ? "is-search-open" : ""
      }`}
    >
      <div
        className={`ob__search_order ${isSearchBarOpen ? "is-search-open" : ""}`}
        id="positionsSearch"
        onClick={() => {
          closeDropdowns();
          setIsSearchBarOpen(true);
        }}
      >
        {!isSearchBarOpen && (
          <>
            {searchVal?.length > 0 ? (
              <div
                style={{
                  height: "21px",
                  width: "21px",
                  padding: "2px 1px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "#112B4A",
                  border: "1px solid rgba(255, 255, 255, 0.15)",
                  borderRadius: "50%",
                  fontSize: "var(--one-font-size-10)",
                }}
              >
                1
              </div>
            ) : (
              <IonIcon
                icon={searchIcon}
                style={{ height: "20px", width: "20px" }}
              />
            )}
          </>
        )}
        {isSearchBarOpen && (
          <IonInput
            clearInput={true}
            clearInputIcon={close}
            labelPlacement="fixed"
            placeholder="Search Positions..."
            aria-label="Search Positions"
            mode="ios"
            value={searchVal}
            onIonInput={(event: any) => {
              setSearchVal(event.detail.value || "");
              CMEDfirebaseLogEvent(
                firebaseEventConfig.CMEDComponentNames.CMED_POSITIONS,
                "CMED_POSITIONS_SEARCH_ORDER",
              );
            }}
            ref={searchRef}
          ></IonInput>
        )}
      </div>
      {isSearchBarOpen && (
        <div
          className="ob__search_order_back_btn"
          onClick={() => {
            setIsSearchBarOpen(false);
            setSearchVal("");
          }}
        >
          <IonIcon icon={arrowBack} style={{ height: "20px", width: "20px" }} />
        </div>
      )}

      {!isSearchBarOpen && (
        <div
          className="ob__visibility_picker_wrapper"
          ref={visibilityPickerRef}
        >
          <div
            className="ob__visibility_picker"
            onClick={() => {
              setIsVisibilityDropDownOpen(!isVisibilityDropDownOpen);
              document.querySelector("ion-item-sliding")?.closeOpened();
            }}
          >
            <p className="ion-no-margin">
              {level === 0
                ? "My Positions"
                : level === 1
                  ? "Desk Positions"
                  : "Company Positions"}
            </p>
            <IonIcon
              icon={expandIcon}
              style={{
                height: "20px",
                width: "20px",
                minWidth: "20px",
                transform: isVisibilityDropDownOpen
                  ? "rotate(180deg)"
                  : "rotate(0)",
              }}
            />
          </div>
          {isVisibilityDropDownOpen && (
            <div className="ob__visibility_picker_dropdown animate__animated animate__fadeIn animate__faster">
              <IonRadioGroup
                value={String(level)}
                onIonChange={(e: any) => {
                  setLevel(Number(e.detail.value));
                  setIsVisibilityDropDownOpen(false);
                }}
              >
                <IonRadio value="0" mode="md" labelPlacement="end">
                  My Positions
                </IonRadio>
                <br />
                <IonRadio value="1" mode="md" labelPlacement="end">
                  Desk Positions
                </IonRadio>
                <br />
                <IonRadio value="2" mode="md" labelPlacement="end">
                  Company Positions
                </IonRadio>
                <br />
              </IonRadioGroup>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PositionsFiltersBar;
